/*
  How It Works
  1. User enters/updates a search query
  2. Input change event is triggered
  3. Toggle form reset button
  4. On form reset event, prevent form reset
  5. Check if allowed to reset form
  6. If allowed, manually reset form
*/

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener(
        "input",
        debounce((e) => {
          this.onChange(e);
        }, 300).bind(this)
      );
    }
  }

  setupEventListeners() {
    if (!this.input) return;

    this.input.form.addEventListener("reset", this.onFormReset.bind(this));

    this.input.addEventListener(
      "input",
      debounce((e) => {
        this.onChange(e);
      }, 300).bind(this)
    );
  }

  // On input change event
  onChange() {
    this.toggleResetButton();
  }

  // Show/hide the button[type="reset"] that clears out the search input in form
  toggleResetButton() {
    // Check if the button is already hidden
    const resetIsHidden =
      this.resetButton.classList.contains("hidden") || this.resetButton.classList.contains("tw-hidden");

    // If user has input and button is not showing, then show it
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove("hidden", "tw-hidden");
    }

    // If input is empty and button is showing, then hide it
    if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add("hidden", "tw-hidden");
    }
  }

  // Form reset event
  onFormReset(e) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    e.preventDefault();

    // Don't reset if the user has selected an element on the predictive search dropdown
    if (!this.shouldResetForm()) return;

    // Manually reset form
    this.resetForm(e);
    this.onChange();
  }

  // Dictates ability to reset form input or not based on user's selected element
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  // Manually reset form
  resetForm(e) {
    this.input.value = "";
    if (this.input.form == e.currentTarget) this.input.focus();
    this.toggleResetButton();
  }
}

customElements.define("search-form", SearchForm);
